//In progress

module.exports = DataObject;

function DataObject(props) {
	shallowCopy(this, props);
}

DataObject.prototype.toJSON = function() {
	var data = {};
	for (var key in this) {
		var val = this[key];
		if (typeof val !== 'function') { //don't include functions
			data[key] = val;
		}
	}
	return data;
};

DataObject.prototype.fromJSON = function(json) {
	if (typeof json != 'object') {
		throw new Error('fromJSON() method expects a JSON object');
	}
	for (var key in json) {
		//only properties defined for the data type will be set
		if (key in this) {
			this[key] = json[key];
		}
	}
};

//in a more generic library (not DataObject) it could be called makeConstructor()
DataObject.createDataType = function(/* parentConstructor (optional), props */) {
	var parentConstructor, props;
	if (arguments.length == 2 && typeof arguments[0] === 'function') {
		parentConstructor = arguments[0];
		props = arguments[1];
	}
	else {
		parentConstructor = DataObject;
		props = arguments[0];
	}
	
	var customInit;
	//A custom initialization function can optionally be supplied.
	if (props.init) {
		customInit = props.init;
		delete props.init;
	}
	var proto = Object.create(parentConstructor.prototype),
		instanceProps = {},
		val,
		pd;
	
	Object.getOwnPropertyNames(props).forEach(function(key) {
		pd = Object.getOwnPropertyDescriptor(props, key);
		val = pd.value;

		//Functions (including getters/setters) are added to the prototype;
		//All other properties are set on the instance, to prevent unintentionally shared prototype properties
		//and so that Object.getOwnPropertyNames() can be used to get an object's own data properties.
		if (pd.get || pd.set || typeof val === 'function') {
			Object.defineProperty(proto, key, pd);
		}
		else {
			Object.defineProperty(instanceProps, key, pd);
		}
	});
	
	var ctor = function(data) {
		//create and initialize any data properties whose values are objects
		//(to prevent unintentionally shared prototype properties)
		DataObject.call(this, instanceProps);
		if (customInit) {
			customInit.apply(this, arguments);
		}
		else if (data) {
			//TODO should we also do this for the customInit?
			//That would require that any custom init functions take a plain object of data properties
			//as its first parameter.
			this.fromJSON(data);
		}
	};
	ctor.prototype = proto;
	proto.constructor = ctor;
	return ctor;
};

function shallowCopy(dest, src) {
	for (var key in src) {
		dest[key] = src[key];
	}
}